module.exports = __webpack_public_path__ + "img/bg4.9cc16909.png";